module.exports = __webpack_public_path__ + "files/8f5efb24f5346dbbb86297f4d7f2e577.png";